/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useContext, useEffect } from 'react';
import { gql, useQuery } from '@apollo/client';
import '@reach/combobox/styles.css';

import styled from 'styled-components';

import { SearchBox } from './SearchBox';
import { Byline, Heading, Tagline } from './Type';
import Button from './Button';

import { ReactComponent as IconOr } from '../assets/icons/or.svg';

import { StyledSearchBox, StyledSearchBoxInner } from './Styles';
import OnlineStockistModal from './OnlineStockistModal';
import Loader from './Loader';
import LocationContext from './Context';
import { useGeolocation } from '../hooks';
import Nearest from './Nearest';
import { ReactComponent as IconRightArrow } from '../assets/icons/right-arrow.svg';
import MarshallsLogo from '../assets/marshalls-helping-you-grow-logo.png';

const StyledOr = styled(IconOr)`
    position: absolute;
    left: 50%;
    top: 0;
    transform: translate(-50%, -50%);
`;

const StyledMarshalls = styled.div`
    margin: 0 auto;
    text-align: center;
    img{
        margin: 24px 0;
    }
    button{
        width: 100%;
    }
`;

const StyledMarshallsHeading = styled.p`
    color: #4F5B6B;
    font-size: 16px;
    line-height: 20px;
    font-weight: bold;
    margin: 0;
`;

const StyledMarshallsSubHeading = styled.p`
    color: #4F5B6B;
    font-size: 12px;
    line-height: 16px;
    margin-top: 24px;
`;


const GET_PRODUCT_META = gql`
    query GET_PRODUCT_META($product: ID!) {
        product(id: $product, idType: DATABASE_ID) {
        ProductMeta {
            productBuyUrl
            productBuyLocation
            productBuyDeliveryTime
        }
        }
    }

`;
export const Search = () => {
    const [showDialog, setShowDialog] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [triedGeo, setTriedGeo] = useState(false);

    const open = () => {
        window?.dataLayer?.push({
            event: 'gtmClick',
            element: {
                category: 'buy online',
                name: 'buy online cta', // set as constant even if the element text changes
                text: 'Buy online', // click text of the element clicked
            },
        });
        setShowDialog(true);
    };
    const close = () => setShowDialog(false);

    const {
        basic,
        layout,
        setSearchType,
        searchType,
        selectedLatLng,
        setSelectedLatLng,
        product,
        brand,
        setFilters,
    } = useContext(LocationContext);
    const { location, getLocation, locationError } = useGeolocation(false);

    const { loading, error, data } = useQuery(GET_PRODUCT_META, {
        variables: {
            product,
        },
    });

    // If we can get the users location and we dont already have one
    useEffect(() => {
        if (location?.latitude && !selectedLatLng && !locationError) {
            setSelectedLatLng({ lat: location.latitude, lng: location.longitude });
            setSearchType('GEO');
        } else if (locationError?.code) {
            // Todo handle errors
        }
        // Only run once
        setTriedGeo(true);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location, locationError]);

    // Center the map on selected Latlng
    useEffect(() => {
        if (!selectedLatLng && !triedGeo && !basic) {
            getLocation();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedLatLng]);

    const handleReset = () => {
        setFilters(undefined);
        setSelectedLatLng(undefined);
    };

    const handleClick = (url) => {
        window?.dataLayer?.push({
            event: 'gtmClick',
            element: {
                category: 'buy now',
                name: 'buy now cta', // set as constant even if the element text changes
                text: 'Buy now', // click text of the element clicked (if applicable)
                detail: url, // domain of the online stockist
            },
        });

        window.open(url, '_blank');
    };



    return (
        <>
            <StyledSearchBox horz={layout === 'horz'}>
                <StyledSearchBoxInner
                    responsive={layout === 'horz'}
                    brand
                    textAlign="left"
                    style={layout === 'horz' ? {} : { paddingBottom: '48px' }}
                >
                    <Heading>Find a stockist</Heading>

                    {basic && (
                        <>
                            {layout !== 'horz' && <Tagline>Search by town, city or postcode</Tagline>}
                            <SearchBox searchLabel="Find a stockist" />
                            {layout !== 'horz' && (
                                <Byline>This information is only used to help us find your closest stockist.</Byline>
                            )}
                        </>
                    )}
                    {!basic && !selectedLatLng?.lat && (
                        <>
                            <Tagline>Search by town, city or postcode</Tagline>

                            <SearchBox searchLabel="Find a stockist" />

                            <Byline>This information is only used to help us find your closest stockist.</Byline>
                        </>
                    )}

                    {!basic && selectedLatLng?.lat && selectedLatLng?.lng && (
                        <Nearest
                            lat={selectedLatLng.lat}
                            lng={selectedLatLng.lng}
                            setLoading={setIsLoading}
                            brand={brand}
                            product={product}
                            searchType={searchType}
                            handleReset={handleReset}
                        />
                    )}
                </StyledSearchBoxInner>

                {(!loading && !data?.product?.ProductMeta?.productBuyUrl && (product || (basic && layout === 'vert'))) && (
                    <StyledSearchBoxInner style={{ paddingTop: '48px' }}>
                        <StyledOr />
                        <Button color="outline" label="Buy online" onClick={open} />
                    </StyledSearchBoxInner>
                )}

                {(!loading && !error && data.product?.ProductMeta?.productBuyUrl && (product || (basic && layout === 'vert'))) && (
                <>

                    <StyledSearchBoxInner style={{ paddingTop: '48px' }} align="center">
                        <StyledOr />

                        <StyledMarshalls>
                                <StyledMarshallsHeading>this product is available to buy online</StyledMarshallsHeading>                       
                                <img src={MarshallsLogo} alt="Marshalls" />
                                <Button icon={<IconRightArrow />} label="Buy now" onClick={() => handleClick(data.product.ProductMeta.productBuyUrl)} />
                                {data.product.ProductMeta.productBuyDeliveryTime && (<StyledMarshallsSubHeading>Estimated UK delivery {data.product.ProductMeta.productBuyDeliveryTime} days</StyledMarshallsSubHeading>)}
                        </StyledMarshalls>
                    </StyledSearchBoxInner>
                </>
                )}
                {isLoading || loading && <Loader loading />}
            </StyledSearchBox>
            <OnlineStockistModal show={showDialog} close={close} productId={product} />
        </>
    );
};
